/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getSubmit: state => (id) => state.submits.find((submit) => submit.id == id),
  // getNotice: state => (id) => state.notices.find((notice) => notice.id == id)
  filteredSubmit: state => state.submits.filter((submit) => {
    return (submit.name.toLowerCase().includes(state.submitSearchQuery.toLowerCase()) || submit.title.toLowerCase().includes(state.submitSearchQuery.toLowerCase()) ||
    submit.update_time.toLowerCase().includes(state.submitSearchQuery.toLowerCase()) || submit.detail.toLowerCase().includes(state.submitSearchQuery.toLowerCase()))
  }),
}
